export type TabStateValue = 'tab-1' | 'tab-2' | 'tab-3'

export const bgImages: Record<TabStateValue, string> = {
  'tab-1': 'hp-bg-1.webp',
  'tab-2': 'hp-bg-2.webp',
  'tab-3': 'hp-bg-3.webp'
}

export const getBackgroundImageUrl = (state: TabStateValue) => {
  const image = bgImages[state] ?? bgImages['tab-1']

  return `/${image}`
}
